/**
 * Cloudflare Workers API クライアント
 * エラーはゲームを止めないよう console.warn のみに留める。
 */

import type { BalloonTrialRecord } from './scoring/balloon.js';
import type { TrustTrialRecord } from './scoring/trust.js';

export const API_BASE: string = import.meta.env.VITE_API_URL ?? '';

async function post(path: string, body: unknown): Promise<void> {
  if (!API_BASE) {
    console.warn(`[api] VITE_API_URL が未設定のためスキップ: ${path}`);
    return;
  }
  try {
    const res = await fetch(`${API_BASE}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (!res.ok) {
      console.warn(`[api] ${path} → HTTP ${res.status}`);
    }
  } catch (err) {
    console.warn(`[api] ${path} 送信エラー:`, err);
  }
}

/** セッション開始を記録する */
export async function createSession(respondentId: string): Promise<void> {
  await post('/sessions', {
    respondent_id: respondentId,
    started_at: new Date().toISOString(),
  });
}

/** BART（風船膨らまし）の試行記録を送信する */
export async function submitBart(
  respondentId: string,
  trials: BalloonTrialRecord[],
): Promise<void> {
  await post('/sessions/bart', {
    respondent_id: respondentId,
    trials,
    submitted_at: new Date().toISOString(),
  });
}

/** Trust Game（分配ゲーム）の試行記録を送信する */
export async function submitTrust(
  respondentId: string,
  trials: TrustTrialRecord[],
): Promise<void> {
  await post('/sessions/trust', {
    respondent_id: respondentId,
    trials,
    submitted_at: new Date().toISOString(),
  });
}

/** メールアドレスを送信する */
export async function submitEmail(
  respondentId: string,
  email: string,
): Promise<void> {
  await post('/sessions/email', {
    respondent_id: respondentId,
    email,
    submitted_at: new Date().toISOString(),
  });
}
